const identityPolicyEndpoints = {
  policy: () => "/identity/policy",
};

export default identityPolicyEndpoints;
